import { useEffect, useState } from "react";
import { Switch } from "@headlessui/react";
import classNames from "classnames";

type ToggleProps = {
  isEnabled?: boolean;
  className?: string;
  label?: string;
  onToggle: (value: boolean) => void;
};

function Toggle({ isEnabled, className, onToggle, label }: ToggleProps) {
  const [enabled, setEnabled] = useState<boolean>(isEnabled ?? false);

  useEffect(() => {
    if (isEnabled == null) return;
    setEnabled(isEnabled);
  }, [isEnabled]);

  const onChange = (value: boolean) => {
    setEnabled(value);
    onToggle(value);
  };

  return (
    <div className={classNames(className)}>
      <Switch
        checked={enabled}
        onChange={onChange}
        className={`${enabled ? "bg-th-primary-900" : "bg-th-primary-100"}
          relative inline-flex h-[30px] w-[54px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
      >
        {label && <span className="sr-only">{label}</span>}
        <span
          aria-hidden="true"
          className={`${enabled ? "translate-x-6" : "translate-x-0"}
            pointer-events-none inline-block h-[26px] w-[26px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
        />
      </Switch>
    </div>
  );
}

export default Toggle;
